export default {
  sendOTP: 'sendOTP',
  verifyOTP: 'verifyOTP',
  verifyOTPBic: 'verifyOTPBic',
  getLenderList: 'getLenderList',
  closeOtpOverLayScreen: 'closeOtpOverLayScreen',
  initLenderListScreen: 'initLenderListScreen',
  openOverlayScreen: 'openOverlayScreen',
  closeOverlayScreen: 'closeOverlayScreen',
  resetUserStatus: 'resetUserStatus',
  closeEligibilityModal: 'closeEligibilityModal',
  openEligibilityModal: 'openEligibilityModal',
  openEligibilityCheckModal: 'openEligibilityCheckModal',
  closeEligibilityCheckModal: 'closeEligibilityCheckModal',
};



// WEBPACK FOOTER //
// ./actions/ntbAction/actionType.js